import { Apollo, ApolloBase } from 'apollo-angular';
import amiraSisQueries from '../data/queries/amira-sis-queries';
import { map } from 'rxjs';
import { Injectable } from '@angular/core';

export type AmiraSISResponse = {
  student: {
    metadata: { selectedTutorSkin: string; selectedTutorRig: string };
  };
};

@Injectable({
  providedIn: 'root',
})
export class AmiraSISService {
  public apollo: ApolloBase;

  constructor(private apolloProvider: Apollo) {
    this.apollo = apolloProvider.use('amiraSIS');
  }
  async getUserSelectedAvatar(userId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.apollo
        .watchQuery<AmiraSISResponse>({
          query: amiraSisQueries.GET_USER,
          variables: { userId },
        })
        .valueChanges.pipe(
          map(result => {
            const selectedTutorSkin =
              result.data?.student?.metadata?.selectedTutorSkin ?? 'Amira';
            const selectedTutorRig =
              result.data?.student?.metadata?.selectedTutorRig ?? 'Amira2';
            const selectedAvatar =
              selectedTutorSkin === 'Amira'
                ? selectedTutorRig
                : selectedTutorSkin;
            return selectedAvatar || 'Amira2';
          })
        )
        .subscribe({
          next: data => {
            resolve(data);
          },
          error: error => {
            console.error(
              'Student Inbox Service - getUserSelectedAvatar query failed:',
              error
            );
            reject(error);
          },
        });
    });
  }
}
